<template>
  <div
    v-if="config"
    class="recommended-container"
  >
    <dashboard-widget-header
      :title="`Recommended for ${firstName}`"
      :icon="widgetIcon"
    />
    <div class="nav-link-container">
      <router-link
        v-for="item in navigationItems"
        :key="item.id"
        :to="item.route"
        @click="sendAnalytics(item)"
      >
        {{ item.name }}
      </router-link>
    </div>
  </div>
</template>

<script>
import DashboardWidgetHeader from '@components/dashboard-widgets/header';
import GlobalMixin from '@/mixins/global';

export default {
  components: { DashboardWidgetHeader },
  mixins: [GlobalMixin],
  props: {
    config: {
      type: Object,
    },
  },
  data() {
    return {
      navigationItems: [],
    };
  },
  computed: {
    widgetIcon() {
      if (this.config) {
        return this.$store.getters['attachments/get'][this.config.iconAttachmentId];
      }
    },
    firstName() {
      const user = this.$store.getters['session/currentUser'];
      if (user) {
        return this.$store.getters['session/currentUser'].firstName;
      }
    },
    navigationGroup() {
      return this.$store.getters['navigationGroups/navigationGroups'][this.config.navigationGroupId];
    },
    question() {
      return this.$store.getters['flashcards/flashcards'][this.config.questionId];
    },
    states() {
      return (this.$store.getters['questionnaireUserStates/all'][0] || {}).state || [];
    },
  },
  created() {
    if (!this.question) {
      this.$store.dispatch('flashcards/fetchFlashcards', { ids: [this.config.questionId] }).then(() => {
        this.setNavigationItems();
      });
    } else {
      this.setNavigationItems();
    }
  },
  methods: {
    sendAnalytics(navItem) {
      this.$analytics.events.selectedNavItem(navItem, this.navigationGroup, this.config.widgetType);
    },
    setNavigationItems() {
      let state = this.states.find(state => state.questionId === this.question.id);
      if (state) {
        let selected = JSON.parse(state.response);
        this.navigationItems = selected.map(s => {
          let answer = this.question.answers.find(a => a.text === s);
          return this.$store.getters['navigationItems/navigationItems'][answer.navigationItemId];
        }).filter(ni => ni);
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.recommended-container {
  @include padded-widget;

  .nav-link-container {
    align-content: center;
    display: flex;

    @include breakpoint(small) {
      flex-wrap: wrap;
    }

    > a {
      align-items: center;
      background: #6f0079;
      border: 3px solid #6f0079;
      border-radius: 40px;
      color: white;
      display: flex;
      font-size: 16px;
      font-weight: $bold;
      height: 72px;
      justify-content: center;
      margin: 0 8px;
      padding: 0 12px;
      text-align: center;
      width: 200px;

      @include breakpoint(small) {
        font-size: 14px;
        height: 40px;
        margin: 0 auto 16px auto;
      }

      &:hover {
        background: white;
        color: #6f0079;
      }
    }

  }
}
</style>
